import type { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { getPublicChallengeBySlugV4Api } from '@repo/sdk';
import { z } from 'zod';

export function registerGetChallenge(server: McpServer): void {
  server.registerTool(
    'get_challenge',
    {
      title: 'Get a Cool Mate challenge by slug',
      description:
        'Fetch full public details of one English challenge by slug (definition, examples, CEFR level, IPA, synonyms, common mistakes).',
      inputSchema: { slug: z.string().min(1).max(200) },
    },
    async ({ slug }) => {
      const { data } = await getPublicChallengeBySlugV4Api(slug);
      return {
        content: [{ type: 'text', text: JSON.stringify(data?.data ?? null) }],
      };
    },
  );
}
